import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
const CHECKMARK_SIZE = 18;
const wrapperStaticStyle = css({
    alignItems: 'center',
    display: 'flex',
});
export function wrapperStyle({ disabled, inverted }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        wrapperStaticStyle,
        css({
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? tokens.opacity.medium : 1,
        }),
    ];
}
export const inputStaticStyle = css({
    cursor: 'inherit',
    height: CHECKMARK_SIZE,
    margin: 0,
    opacity: 0,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: CHECKMARK_SIZE,
});
export const labelStaticStyle = css({
    color: theme.text.main,
    cursor: 'inherit',
    lineHeight: tokens.lineHeights.default,
    paddingLeft: tokens.spacingNew.xsmall,
    paddingTop: '1px',
    userSelect: 'none',
});
const checkmarkStaticStyle = css({
    '&::after': {
        borderRadius: '6px',
        content: '""',
        display: 'block',
        inset: 0,
        margin: '-3px',
        pointerEvents: 'none',
        position: 'absolute',
        transition: 'box-shadow 125ms ease-out',
        zIndex: tokens.zIndex.default,
    },
    alignItems: 'center',
    backgroundColor: theme.background.contrast,
    borderColor: theme.border.interactive,
    borderRadius: tokens.borderRadius.medium,
    borderStyle: 'solid',
    borderWidth: tokens.borderWidth.thin,
    color: theme.text.inverse,
    display: 'flex',
    flexShrink: 0,
    height: CHECKMARK_SIZE,
    justifyContent: 'center',
    pointerEvents: 'none',
    position: 'relative',
    transition: 'background-color 75ms ease-out, border-color 75ms ease-out',
    width: CHECKMARK_SIZE,
});
const checkmarkErrorStaticStyle = css({
    borderColor: theme.error.darker,
    boxShadow: `0 0 0 1px ${theme.error.darker}`,
});
const checkmarkFocusStaticStyle = css({
    '&::after': {
        boxShadow: `0 0 0 2px ${theme.border.focusOutline}`,
    },
});
const checkmarkColorStaticStyle = {
    checked: css({
        backgroundColor: theme.blue.darker,
        borderColor: theme.blue.darker,
    }),
    disabled: css({
        backgroundColor: theme.background.tertiary,
        borderColor: theme.border.interactive,
    }),
    disabledChecked: css({
        backgroundColor: theme.text.subtle,
        borderColor: theme.text.subtle,
    }),
};
export function checkmarkStyle({ checked, disabled, hasError, isFocusVisible, isIndeterminate, }) {
    const isChecked = checked || isIndeterminate;
    return [
        checkmarkStaticStyle,
        ...(isChecked ? [checkmarkColorStaticStyle.checked] : []),
        ...(disabled
            ? [
                isChecked
                    ? checkmarkColorStaticStyle.disabledChecked
                    : checkmarkColorStaticStyle.disabled,
            ]
            : []),
        ...(isFocusVisible ? [checkmarkFocusStaticStyle] : []),
        ...(hasError ? [checkmarkErrorStaticStyle] : []),
    ];
}
